import { createTheme } from "@mui/material";
import { CONFIG } from "../config";

export const createAppTheme = (themeMode, config) =>
  createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
        xxl: 2048,
      },
    },
    palette: {
      mode: themeMode === "dark" ? "dark" : CONFIG.themeMode,
      gradient:
        themeMode === "dark"
          ? "linear-gradient( to bottom, #191B1F 0%, #191B1F 550px, #25282D 550px, #25282D 150%)"
          : themeMode === "light"
            ? `linear-gradient( to bottom, ${config.primaryColour} 0%, ${config.primaryColour} 550px, #EFEFEF 550px, #EFEFEF 150%)`
            : CONFIG.themeMode === "light"
              ? `linear-gradient( to bottom, ${config.primaryColour} 0%, ${config.primaryColour} 550px, #EFEFEF 550px, #EFEFEF 150%)`
              : "linear-gradient( to bottom, #191B1F 0%, #191B1F 550px, #25282D 550px, #25282D 150%)",
      primary: { main: config.primaryColour },
      secondary: { main: config.secondaryColour },
      // Add semantic colors for notifications and alerts
      error: {
        main: "#d32f2f",
        light: "#ef5350",
        dark: "#c62828",
        contrastText: "#fff",
      },
      warning: {
        main: "#ed6c02",
        light: "#ff9800",
        dark: "#e65100",
        contrastText: "#fff",
      },
      success: {
        main: "#2e7d32",
        light: "#4caf50",
        dark: "#1b5e20",
        contrastText: "#fff",
      },
      info: {
        main: "#0288d1",
        light: "#03a9f4",
        dark: "#01579b",
        contrastText: "#fff",
      },
    },
    typography: { fontFamily: "Inter, sans-serif" },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: ({ theme }) => ({
            background:
              theme.palette.mode === "dark"
                ? "linear-gradient(145deg, rgba(40,40,45,1) 0%, rgba(35,35,40,1) 100%)"
                : "linear-gradient(145deg, rgba(255,255,255,1) 0%, rgba(245,245,245,1) 100%)",

            border: `1px solid ${
              theme.palette.mode === "dark"
                ? "rgba(255,255,255,0.1)"
                : "rgba(0,0,0,0.1)"
            }`,
            borderRadius: "16px",
          }),
        },
      },
      MuiCardContent: {
        styleOverrides: {
          root: {
            "&:last-child": {
              padding: "8px",
            },
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: ({ theme }) => ({
            background:
              theme.palette.mode === "dark" ? "#111111" : CONFIG.primaryColour,
          }),
        },
      },
    },
  });
